import React, { useState, useEffect } from "react";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextField from "canvas-core-react/lib/TextField";
import { useHistory } from "react-router-dom";
import { getRoles } from "../../../../Redux/reducer/session";
import { moduleAction } from "../../../utils/functions";
import contactProvider from "../../../../../static/images/contactProvider.svg";
import iconEdit from "../../../../../static/images/icon-addnew-18px.svg";
import { MOD_PROVID, MOD_DISCONT_PROV, WRITE } from "../../../../permissions";
import plusImage from "../../../../../static/images/plus.svg";
import Modal from "../../../utils/customModal";
import AccountsModal from "./additionsAccounts/accounts-modal";
import { useTranslation } from "react-i18next";
import { loadingHtml, sucessInfoModal } from "../../../utils/functions.js";
import useApi from "../../../hooks/useApi";
import { getCreditLine } from "../../../../Redux/reducer/credit-line";
import SettlementAccount from "./SettlementAccount";
import { useSelector } from "react-redux";

export const ProviderInfo = ({ provider, changeInfo }) => {
  const { roles, creditLines } = useSelector((state) => ({
    roles: getRoles(state),
    creditLines: getCreditLine(state),
  }));

  const { postApiCAll } = useApi();
  const { t } = useTranslation();
  const [showAddAccount, setShowAddAccount] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  const [accountsModal, setAccountsModal] = useState({
    show: false,
    onClose: undefined,
  });

  const history = useHistory();

  useEffect(() => {
    const reverseCreditLines = creditLines.filter(
      ({ isReverseLine }) => isReverseLine
    );
    if (
      provider.country.code == "CR" &&
      reverseCreditLines.length >= 2 &&
      provider.provider.accounts.length == 1
    ) {
      setShowAddAccount(true);
    }
  }, []);

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const closeAccountModal = () => {
    setAccountsModal({ show: false, onClose: undefined });
  };

  const closeAndReset = () => {
    closeModal();
  };

  const getModalResponse = () => {
    let button = {
      formBtn: { text: t("general.buttons.accept"), action: closeAndReset },
    };
    let content = sucessInfoModal(
      t("providers.accounts.modal.successTitle"),
      t("providers.accounts.modal.message"),
      button
    );
    setModal({ show: true, content, onClose: closeAndReset });
  };

  const checkAccounts = () => {
    return provider.provider.accounts.filter(
      (account) => account.accountCurrency === "CRC" || "USD"
    );
  };

  const saveAccount = (body) => {
    closeAccountModal();
    setModal({ show: true, content: loadingHtml(), onClose: undefined });

    postApiCAll(
      `/providers/company/add-new-account/${provider.provider.id}`,
      body,
      {}
    )
      .then(() => {
        closeModal();
        getModalResponse();
      })
      .catch(() => {
        let button = {
          formBtn: { text: t("general.buttons.close"), action: closeModal },
        };
        let content = sucessInfoModal(
          t("providers.accounts.modal.successTitle"),
          t("providers.accounts.modal.error"),
          button
        );
        setModal({ show: true, content, onClose: closeModal });
      });
  };

  const { editText, providerInfo } = {
    editText: t("general.labels.edit"),
    providerInfo: t("providers.profile", { returnObjects: true }),
  };

  return provider !== undefined && provider.businessId !== undefined ? (
    <>
      <div className="actions-title">
        <img src={contactProvider} className="icon" />
        <p>{providerInfo.title}</p>
        {moduleAction(roles, MOD_PROVID, WRITE) && (
          <div className="new-edit-div">
            <p className="new-edit-provider" onClick={() => changeInfo()}>
              {editText}
            </p>
            <img
              src={iconEdit}
              className="iconEdit"
              onClick={() => changeInfo()}
            />
          </div>
        )}
      </div>
      <div className="profile custom-canvas">
        <div className="close" onClick={() => history.push(`/providers`)}></div>
        <h3>{providerInfo.subtitle}</h3>
        <Grid fluid={true}>
          <Row justifyContent="spaceBetween">
            <Column lg={5} md={5}>
              <TextField
                className="input input--text input--active"
                name="companyName"
                id="companyName"
                disabled={true}
                value={provider.name}
                label={t("providers.detail.providerName")}
              />
            </Column>
            <Column lg={5} md={5}>
              <TextField
                name="businessId"
                id="businessId"
                disabled={true}
                value={provider.businessId || ""}
                label={t("providers.detail.identification")}
              />
            </Column>
          </Row>
          <Row justifyContent="spaceBetween">
            <Column lg={5} md={5}>
              <TextField
                name="address"
                id="address"
                disabled={true}
                value={provider.provider.address}
                label={t("providers.detail.address")}
              />
            </Column>
            <Column lg={5} md={5}>
              <TextField
                name="phone"
                id="phone"
                disabled={true}
                value={provider.provider.phoneProvider || ""}
                label={t("providers.detail.phone")}
              />
            </Column>
          </Row>
          <Row justifyContent="spaceBetween">
            <Column lg={5} md={5}>
              <TextField
                name="city"
                id="city"
                disabled={true}
                value={provider.provider.residenceCity || ""}
                label={t("providers.detail.city")}
              />
            </Column>
            <Column lg={5} md={5}>
              <TextField
                name="country"
                id="country"
                disabled={true}
                value={provider.provider.country.name || ""}
                label={t("providers.detail.country")}
              />
            </Column>
          </Row>
          <Row justifyContent="spaceBetween">
            <Column lg={5} md={5}>
              <TextField
                name="contact"
                id="contact"
                disabled={true}
                value={provider.provider.notificationNameProvider || ""}
                label={t("providers.detail.contact")}
              />
            </Column>
            <Column lg={5} md={5}>
              <TextField
                name="notificationEmail"
                id="notificationEmail"
                disabled={true}
                value={provider.provider.notificationEmailProvider || ""}
                label={t("providers.detail.notificationEmail")}
              />
            </Column>
          </Row>
        </Grid>
        {showAddAccount ? (
          <div className="custom-flex-space">
            <h3 className="flex-element">
              {t("providers.detail.titleAccountSettlement")}
            </h3>
            {moduleAction(roles, MOD_DISCONT_PROV, WRITE) &&
            provider.provider.toBillDiscount === true &&
            checkAccounts().length <= 1 ? (
              <div
                onClick={() => {
                  setAccountsModal({
                    show: true,
                    onClose: undefined,
                  });
                }}
                className="flex-element custom-flex-space"
                id="modaldiv"
              >
                <p className="add-account mt0">{t("providers.addAccount")}</p>
                <img
                  className="icon-plus-add mt0"
                  src={plusImage}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="custom-flex-space">
            <h3 className="flex-element">
              {t("providers.detail.titleAccountSettlement")}
            </h3>
          </div>
        )}
        {provider.provider.accounts.map((a, index) => (
          <SettlementAccount key={index} index={index} account={a} />
        ))}

        <Modal show={modal.show} handleClose={modal.onClose}>
          {modal.content}
        </Modal>

        <Modal show={accountsModal.show} handleClose={accountsModal.onClose}>
          <AccountsModal
            handleClose={closeAccountModal}
            data={provider}
            handleSave={saveAccount}
          />
        </Modal>
      </div>
    </>
  ) : (
    <p>Provider not found</p>
  );
};

export default ProviderInfo;
